import React from "react";
import { Card } from "../card";

export function ContactSkeleton() {
  return (
    <div>
      <div className="h-3 w-40 bg-secondary opacity-10 rounded-full dark:bg-gray-600 my-4 lg:my-3"></div>
      <div className="pt-2 lg:pt-4">
        <Card>
          <div className="flex flex-col space-y-6 py-4 px-3 lg:p-4">
            <div className="flex justify-between items-center">
              <div className="h-3 w-40 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
              <div className="flex justify-end items-center space-x-3">
                <div className="hidden lg:flex w-28 h-8 rounded-md bg-secondary opacity-10 dark:bg-gray-700"></div>
                <div className="w-28 h-8 rounded-md bg-secondary opacity-10 dark:bg-gray-700"></div>
              </div>
            </div>
            <div className="py-6 flex flex-col space-y-8">
              <div className="flex justify-between items-center">
                <div className="h-3 w-28 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
                <div className="h-3 w-28 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
              </div>
              <div className="flex justify-between items-center">
                <div className="h-3 w-28 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
                <div className="h-3 w-28 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
              </div>
              <div className="flex justify-between items-center">
                <div className="h-3 w-28 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
              </div>
            </div>
            <div className="h-12 rounded w-full bg-secondary opacity-10 dark:bg-gray-600 mb-2.5"></div>
            {Array.from({ length: 4 }, (_, index) => (
              <div
                key={index}
                className="flex justify-between items-center pt-2">
                <div className="h-3 w-28 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
                <div className="h-3 w-14 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
                <div className="hidden lg:flex h-3 w-14 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
                <div className="h-3 w-24 bg-secondary opacity-10 rounded-full dark:bg-gray-600 mb-2.5"></div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
